import styled from "styled-components";

export const Container = styled.div`
  &.velotax-container {
    .velotax-content {
      width: 100%;
      max-width: 1032px;
      margin: 0 auto;
      padding: 0 1rem;
      h1.page-title {
        font-size: 28px;
        margin-bottom: 1rem;
        margin-left: 60px;
        text-align: left;
        display: flex;
        align-items: center;
        button {
          margin-right: 0.5rem;
          color: var(--velotax-font-color);
          svg {
            font-size: 24px;
            transform: translateY(2px);
          }
        }
      }
      .divider {
        width: 100%;
        max-width: 80px !important;
        background-color: var(--ant-primary-color);
        height: 2px;
        margin-bottom: 2rem;
        margin-left: 60px;
      }
      .subtitle {
        font-size: 16px;
        color: var(--velotax-font-color);
      }
      .trustpilot-trustbox-widget {
        margin: 32px 0 32px -16px;
        width: calc(100% + 32px);
      }
      .selos {
        display: flex;
        margin: 0 0 48px;
        .selo {
          display: flex;
          padding: 0 24px;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          width: calc(100% / 3);
          .ant-typography {
            display: block;
            margin-top: 8px;
            font-size: 16px;
            line-height: 20px;
            text-align: center;
            font-size: 13px;
            .anticon {
              margin-left: 5px;
              vertical-align: -0.2em;
            }
            strong {
              display: block;
              font-weight: 700;
              color: rgb(0, 204, 139);
            }
          }
          &.trustpilot {
            .excelente {
              display: block;
              font-size: 18px;
              font-weight: 700;
              margin: 0 0 8px;
            }
            .avaliacoes {
              display: flex;
              height: 24px;
              font-size: 16px;
              margin: 16px 0 10px;
              align-items: center;
              justify-content: center;
              svg {
                margin: 0 0 2px 0;
              }
            }
          }
        }
      }
    }
  }

  .divSwitchAnualMonth {
    width: 100%;
    display: flex; 
    flex-direction: row; 
    gap: 15px;
    color: black;
    justify-content: center;
  }

  .switchAnualMonth {
    display: flex;
    margin-bottom: 20px;
    background-color: var(--ant-primary-color);
  }

  .hide-plan {
    display: none;
  }

  @media only screen and (max-device-width: 812px) {
    &.velotax-container {
      .velotax-content {
        width: 100%;
        .selos {
          flex-direction: column;
          .selo {
            width: 100%;
            padding: 12px 24px;
          }
        }
      }
    }
  }
  
  /* Media query para centralizar o título em telas menores */
  @media (max-width: 1200px) {
    &.velotax-container {
      .velotax-content {
        h1.page-title {
          text-align: center;
          justify-content: center;
          margin-left: 0;
        }
      }
    }
  }
`;

export const PlanosContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: center;
  align-items: ${({ isMobile }) => isMobile ? 'center' : ''};
  width: 100%;
  max-width: 100%;
  gap: 1rem;

  .plan {
    padding: 13px;
    overflow: hidden;
    position: relative;
    border-radius: 8px;
    background-color: white;
    flex: 1;
    
    box-shadow: 0 1px 10px 1px rgba(0,0,0, 0.15);
    .plan-name {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      text-align: center;
      margin-bottom: 0;
      color: var(--velotax-font-color);
    }
    .plan-price {
      text-align: center;
      position: relative;
      font-size: 24px;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 4px;
      color: var(--velotax-font-color);
      .plan-price-main {
        font-size: 48px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: -1.92px;
      }

      .plus {
        margin-right: 4px;
        position: absolute;
        left: 1rem;
        bottom: 0;
      }
    }

    .price-crossed-off {
      position: absolute;
      font-size: 16px;
      font-weight: 700;
      color: var(--ant-primary-color);
      left: 22%;
      top: 18%;
    }

    .price-crossed-off-discount {
      position: absolute;
      font-size: 12px;
      color: var(--ant-primary-color);
      left: 56%;
      top: 18.5%;
    }

    .crossed-off {
        position: absolute;
        left: 21%;
        top: 20.1%;
        height: 1px;
        width: 75px;
        background-color: var(--ant-primary-color);
      }

    .plan-price-desc {
      display: block;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      margin-bottom: 2rem;
      color: var(--velotax-font-color);
    }
    .plan-for {
      width: 100%;
      display: block;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: center;
      margin: 4px auto 2.5rem;
      color: var(--velotax-font-color-ghost);
    }
    .plan-includes {
      display: block;
      margin: 24px 0 0;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: var(--velotax-font-color);
    }
    .plan-benefits {
      .plan-benefit {
        display: flex;
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
        margin-top: 2px;
        color: var(--velotax-font-color-ghost);
        svg {
          width: 16px;
          height: 16px;
          min-width: 16px;
          min-height: 16px;
          margin-right: 4px;
        }
        svg.check {
          fill: var(--ant-success-color);
        }
        .info {
          width: 12px;
          height: 12px;
          margin: 2px 0 0 4px;
          color: var(--velotax-font-color);
          cursor: pointer;
          svg {
            width: 12px;
            height: 12px;
            min-width: 12px;
            min-height: 12px;
            margin-right: 0;
          }
        }
        .ant-tooltip-inner {
          background-color: rgba(0, 0, 0, 0.9);
        }
      }
    }
    .plan-popular {
      top: 0;
      right: 0;
      width: 150px;
      height: 20px;
      display: flex;
      font-size: 10px;
      font-weight: 700;
      line-height: 16px;
      position: absolute;
      color: var(--white);
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      background-color: var(--ant-primary-color);
      transform: rotateZ(40deg) translateX(44px) translateY(-13px);
    }

    .ant-tooltip-inner {
      padding: 10px 15px;
      top: 0;
      display: inline-block;
      border-radius: 10px;
      border-bottom-right-radius: 0px;
      z-index: 2;
      max-width: 200px;
      box-shadow: none;
      word-wrap: break-word;
    }
  }

  .discount {
    .plus {
      left: 0.25rem !important;
    }
  }
  /* Media query para telas menores que 1200px - cards se empilham */
  @media (max-width: 1300px) {
    flex-direction: column;
    align-items: center;
    
    .plan {
      width: 100%;
      max-width: 400px;
      margin: 0 0 1rem 0;
      flex: none;
    }
  }
`;
